import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJActionCommon from '../../../redux/action/FJActionCommon.js';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJCommonRightHeaderView from '../../FJMainPreview/FJDisplayHeader/FJCommonRightHeaderView.jsx';

const FJImageEnhancerHeaderButtons = () => {
    const dispatch = useDispatch();
    const isShow = useSelector(state => state.imageEnhancer.isDone);
    const list = useSelector(state => state.imageEnhancer.imageEnhancerCreationList);
    const selectedDownloadList = useSelector(state => state.common.selectedDownloadList);
    const isApplyButton = useSelector(state => state.common.isApplyButton);
    const batchDownloadLoading = useSelector(state => state.common.batchDownloadLoading);

    const _list = useMemo(() => {
        return list.map(item => {
            const { id, imgUrl, originalUrl, width, height } = item;
            return {
                id,
                width,
                height,
                url: imgUrl || originalUrl,
            };
        });
    }, [list]);

    const _selectAll = () => {
        dispatch(FJActionCommon.setSelectedDownloadItemsAction([...list]));
    };

    const _deselectAll = () => {
        dispatch(FJActionCommon.setSelectedDownloadItemsAction([]));
    };

    const _selectItem = (id, selected) => {
        if (selected) {
            const item = list.find(item => item.id === id);
            if (selectedDownloadList.indexOf(item) === -1) {
                const newList = [...selectedDownloadList];
                newList.push(item);
                dispatch(FJActionCommon.setSelectedDownloadItemsAction(newList));
            }
        } else {
            const index = selectedDownloadList.findIndex(item => item.id === id);
            if (index !== -1) {
                const newList = selectedDownloadList.filter(item => item.id !== id);
                dispatch(FJActionCommon.setSelectedDownloadItemsAction(newList));
            }
        }
    };

    const _download = () => {
        dispatch(FJActionCommon.downloadSelectedItemsAction());
    };

    const _onApply = () => {
        const item = _list[0];
        const { url, width, height } = item;
        dispatch(FJActionEditPage.applyToEditPageAction(url, { size: { width, height } }));
    };

    const _onAddToMediaLibrary = () => {
        const list = _list.map(item => item.url);
        dispatch(FJActionEditPage.addMultipleMediaToMediaLibraryAction(list, { from: 'generate' }));
    };

    if (!isShow) return null;

    return (
        <FJCommonRightHeaderView
            useApplyButton={isApplyButton}
            list={_list}
            selectedDownloadList={selectedDownloadList}
            isDownloading={batchDownloadLoading}
            selectAll={_selectAll}
            deselectAll={_deselectAll}
            selectItem={_selectItem}
            onDownload={_download}
            onApply={_onApply}
            isEditPage={window.isEditPage}
            onAddToMediaLibrary={_onAddToMediaLibrary}
        />
    );
};

export default FJImageEnhancerHeaderButtons;
